<script>
export const group = 'Full'
</script>

<script setup>
import Video from '../default/Video.vue'
import Transition4 from './transitions/Transition4.vue'
</script>

<template>
  <Transition4>
    <Video v-bind="$attrs" />
  </Transition4>
</template>
